import FsLightbox from "fslightbox-react";
import React, { useState } from "react";
import { Carousel } from "../../common/components/Carousel";
import { ProductItem } from "./ProductItem";
import { productPageItemType } from "../../common/types/product";

interface ProductSliderProps {
	title?: string;
	description?: string;
	slides: productPageItemType[];
}

export function ProductSlider({
	title = "Extensive Search Options",
	description,
	slides,
}: ProductSliderProps) {
	const [toggler, setToggler] = useState(false);
	const [zoomSlideImage, setZoomSlideImage] = useState(slides[0].visual.url);

	const handleZoomButtonClick = (image) => {
		setToggler(!toggler);
		setZoomSlideImage(image);
	};

	const productSlides = slides.map((slide, index) => {
		const { title, description, descriptionBottom, list, visual } = slide;

		return (
			<ProductItem
				key={index}
				description={description}
				descriptionBottom={descriptionBottom}
				title={title}
				list={list}
				visual={visual}
				onZoomButtonClick={handleZoomButtonClick}
			/>
		);
	});

	return (
		<section className="section--product-slider">
			<div className="container">
				<h2 className="section-title">{title}</h2>
				{description && (
					<p className="section-description">{description}</p>
				)}
				<Carousel
					options={{
						slidesToShow: 1,
					}}
					slides={productSlides}
				/>
				<FsLightbox toggler={toggler} sources={[zoomSlideImage]} />
			</div>
		</section>
	);
}
